import React from 'react';import PropTypes from 'prop-types';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { formatPrice } from '../../../../common/formatting';
import { profile } from '../../../../modules/customer'
import { invoices } from '../../../../modules/customer/profile';

const options = [
    // { value: 'sendInvoice', label: 'Send faktura' },
    // { value: 'changeInvoice', label: 'Fakturaendringer' },
    // { value: 'infoAboutDebtCollection', label: 'Inkassoinformasjon' },
    // { value: 'credit', label: 'Kreditere/debitere' }
];

const getInvoiceStatusClass = status => classnames('invoiceStatus status-circle circle-small', {
    'status-unknown': status === 'Undefined',
    'status-warn': status === 'Dunning' || status === 'Collection',
    'status-ok': status === 'Ok'
});

const InvoiceBox = ({ invoices, financialBalance, getPDF, customerId }) => {

    return (
        <div>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-4">
                        <strong>Balanse:</strong>
                    </div>
                    <div className="col-xs-2 text-left boxText">
                        <strong>{financialBalance.totalBalance},-</strong>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        Til forfall:
                    </div>
                    <div className="col-xs-2 text-left boxText">
                        {financialBalance.currentDue},-
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        Ikke forfalt:
                     </div>
                    <div className="col-xs-2 text-left boxText">
                        {financialBalance.notYetDue},-
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4">
                        Ikke betalt:
                    </div>
                    <div className="col-xs-2 text-left boxText">
                        {financialBalance.overdue},-
                    </div>
                </div>
                <hr />
                {invoices.map(function (invoice, i) {
                    let invoiceStatusClass = getInvoiceStatusClass(invoice.status);
                    return (
                        <div key={i} className="row invoice">
                            <div className="col-lg-12">
                                <div className="row">
                                    <div className="col-lg-4  col-md-4">
                                        <span><strong>FAKTURA #{invoice.invoiceNumber}</strong></span>
                                    </div>
                                    <div className="col-lg-3 col-md-3 boxText text-left">
                                        {invoice.dueDate}
                                    </div>
                                    <div className="col-lg-2 col-md-2 center">
                                        {invoice.pdfAvailable
                                            && <a onClick={e => {
                                                e.preventDefault();
                                                getPDF(customerId, invoice.invoiceNumber)
                                            }} href="#">
                                                <img
                                                    className="icon"
                                                    src="/icons/pdf_ic.svg"
                                                    alt="" />
                                            </a>
                                        }
                                    </div>
                                    <div className="col-lg-3 col-md-3 text-right">
                                        <span className={invoiceStatusClass}></span>
                                        <span className="invoiceValue">{formatPrice(invoice.amount)}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div >

    );
};

const mapDispatchToProps = (dispatch, props) => ({
    getPDF: (customerId, invoiceNumber) => dispatch(invoices.actions.fetchInvocePdf(customerId, invoiceNumber)),
});

const mapStateToProps = createStructuredSelector({
    customerId: profile.selectors.getCustomerID
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceBox);